export const LEAGUES = [
  { id: '4328', name: 'Premier League', fullName: 'English Premier League', country: 'England', season: '2025-2026' },
  { id: '4335', name: 'La Liga', fullName: 'Spanish La Liga', country: 'Spain', season: '2025-2026' },
  { id: '4332', name: 'Serie A', fullName: 'Italian Serie A', country: 'Italy', season: '2025-2026' },
  { id: '4331', name: 'Bundesliga', fullName: 'German Bundesliga', country: 'Germany', season: '2025-2026' },
  { id: '4334', name: 'Ligue 1', fullName: 'French Ligue 1', country: 'France', season: '2025-2026' }
];

export const DEFAULT_LEAGUE = '4328'; // Premier League
